import React from "react";

/**
 * V17 acid button. Variants: solid (lime + pink shadow), outline (white border).
 */
export const Button = ({
  children,
  variant = "solid",
  size = "md",
  as: Tag = "button",
  className = "",
  ...rest
}) => {
  const pad =
    size === "sm" ? "px-5 py-2.5 text-[11px]" : "px-7 py-3.5 text-[12px]";
  const base =
    `inline-flex items-center justify-center gap-2 ${pad} font-black tracking-[0.3em] uppercase rounded-full transition-transform hover:scale-[1.03] cursor-pointer`;
  const variants = {
    solid: {
      background: "#c8ff2a",
      color: "#060606",
      border: "1px solid #c8ff2a",
      boxShadow: "0 6px 0 #ff2a8f, 0 12px 30px -6px rgba(200,255,42,0.5)",
    },
    pink: {
      background: "#ff2a8f",
      color: "#060606",
      border: "1px solid #ff2a8f",
      boxShadow: "0 6px 0 #c8ff2a, 0 12px 30px -6px rgba(255,42,143,0.5)",
    },
    outline: {
      background: "transparent",
      color: "#fff",
      border: "2px solid #fff",
    },
    ghost: {
      background: "rgba(255,255,255,0.05)",
      color: "#fff",
      border: "1px solid rgba(255,255,255,0.18)",
    },
  };
  return (
    <Tag className={`${base} ${className}`} style={variants[variant]} {...rest}>
      {children}
    </Tag>
  );
};

export default Button;
